import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import api from "../../api";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../../utils/toastMessages";
import crossIcon from "../../assets/icons/crossIcon.png";
import fileIcon from "../../assets/icons/sboxfile.png";
import linkIcon from "../../assets/icons/sboxlink.png";
import { BsArrowRepeat } from "react-icons/bs";
import { formatFileType } from "../../utils/FileType";
import uploadIcon from "../../assets/icons/material-symbols_file-upload.png";
import { toast } from "react-toastify";
import { formatDateToUserTimeZone } from "../../utils/formatDate";
import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_API_URL}/users`;

const TrainingManagement = ({ uploadedFiles = [] }) => {
  const fileInputRef = useRef();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFilesList, setUploadedFilesList] = useState([]);
  const [selectedFileForPreview, setSelectedFileForPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);

  // 🆕 summary states
  const [summaryDataList, setSummaryDataList] = useState([]);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  // const [selectedrole, setSelectedRole] = useState("user");
  const [role, setRole] = useState("personal");
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedUserObj, setSelectedUserObj] = useState(null);
  const [Description, setDescription] = useState("");

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchUploadedFiles = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/uploaded-files/files`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!res.ok) throw new Error("Failed to fetch uploaded files");
      const data = await res.json();
      // setUploadedFilesList(data);
      // ✅ filter by MIME types
      const allowedMimeTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "text/plain",
        "text/csv",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",

        // PowerPoint
        "application/vnd.ms-powerpoint", // .ppt
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx

        // Audio & Video
        "audio/mpeg", // .mp3
        "video/mp4", // .mp4

        // Images
        "image/png", // .png
        "image/jpeg", // .jpeg / .jpg
      ];

      // const onlyDocs = data.filter((f) =>
      //   allowedMimeTypes.includes(f.type?.toLowerCase())
      // );
      console.log("Fetched uploaded documents:", data);
      setUploadedFilesList(data);
      calculateSummaryStats(data);
    } catch (err) {
      console.error("Error fetching uploaded documents:", err);
      showErrorToast(TOAST_MESSAGES.UPLOAD.FAILED);
    }
  };

  useEffect(() => {
    fetchUploadedFiles();
  }, []);
  const allowedExtensions = [
    "pdf",
    "docx",
    "txt",
    "doc",
    "pptx",
    "xlsx",
    "mp3",
    "wav",
    "aac",
    "flac",
    "mp4",
    "mov",
    "avi",
    "mkv",
    "flv",
    "png",
    "jpg",
    "jpeg",
    "gif",
    "bmp",
    "tiff",
  ];

  const handleFileSelect = (e) => {
    const newFiles = Array.from(e.target.files);

    const updatedFiles = [...selectedFiles];

    const supportedFiles = [];
    const unsupportedFiles = [];

    // Split supported + unsupported
    newFiles.forEach((file) => {
      const ext = file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.includes(ext)) {
        supportedFiles.push(file);
      } else {
        unsupportedFiles.push(file);
      }
    });

    // ❌ Toast for unsupported files
    if (unsupportedFiles.length > 0) {
      const names = unsupportedFiles.map((f) => f.name).join(", ");
      showErrorToast(`Unsupported file format.`);
      // showErrorToast(`Unsupported file format: ${names}`);
    }

    // 🚫 Skip if no supported files remain
    if (supportedFiles.length === 0) return;

    // ✔ Add only non-duplicate supported files
    supportedFiles.forEach((file) => {
      const exists = updatedFiles.some(
        (f) => f.name === file.name && f.size === file.size
      );
      if (!exists) {
        updatedFiles.push(file);
      }
    });

    setSelectedFiles(updatedFiles);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFileSelect({ target: { files: e.dataTransfer.files } });
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDelete = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
  };

  const handleCancel = () => {
    // if no documents present, just ignore
    if (!selectedFiles || selectedFiles.length === 0) {
      showErrorToast("No document to cancel.");
      return;
    }

    setIsCancelling(true);
    setTimeout(() => {
      setSelectedFiles([]);
      fileInputRef.current.value = null;
      setIsCancelling(false);
    }, 500);
  };

  const handleChangeStatus = async (fileId, newStatus) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/approve-or-reject`,
        { file_id: fileId, approval_status: newStatus, notes: "" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      showSuccessToast(`Status updated to ${newStatus}`);
      fetchUploadedFiles();
    } catch (err) {
      console.error("❌ Error updating status:", err);
      showErrorToast("Failed to update status");
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  // 🆕 Fetch summary after upload
  const fetchSummaryFromBackend = async (uploadIds) => {
    try {
      const idsQuery = uploadIds.join(",");
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/uploaded-files/summary?ids=${idsQuery}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSummaryDataList(res.data);
      setShowSummaryModal(true);
    } catch (err) {
      console.error("Failed to fetch summaries:", err);
      showErrorToast("Failed to fetch summaries.");
    }
  };

  // 🆕 Regenerate specific summary
  const regenerateSummary = async (fileId, index) => {
    try {
      setLoadingIndex(index); // 🚫 disable button for this index

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/regenerate-summary`,
        { file_id: fileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const newSummary = res.data.summary;

      setSummaryDataList((prevList) => {
        const updatedList = [...prevList];
        updatedList[index] = {
          ...updatedList[index],
          summary: newSummary,
        };
        return updatedList;
      });

      showSuccessToast("Summary regenerated!");
    } catch (err) {
      console.error("Failed to regenerate summary:", err);
      showErrorToast("Regeneration failed.");
    } finally {
      setLoadingIndex(null); // ✅ re-enable button
    }
  };

  console.log("selectedUser", selectedUserObj);

  const handleUpload = async () => {
    let duplicateCheckResponse;

    try {
      if (selectedFiles.length === 0) {
        showErrorToast("Please select at least one file!");
        return;
      }

      setIsAdded(true);

      /* ===========================
       1️⃣ CHECK DUPLICATES
    ============================ */
      const checkFormData = new FormData();
      selectedFiles.forEach((file) => checkFormData.append("files", file));
      checkFormData.append("mode", "global");

      duplicateCheckResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/checkDuplicates`,
        checkFormData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const { duplicates = [], new_files = [] } =
        duplicateCheckResponse.data || {};

      /* ===========================
       2️⃣ HANDLE ALL DUPLICATES
    ============================ */
      if (new_files.length === 0) {
        showErrorToast("All selected files are duplicates. No files uploaded.");
        setSelectedFiles([]);
        return;
      }

      /* ===========================
       3️⃣ FILTER FILE OBJECTS
       Upload ONLY new_files
    ============================ */
      const filesToUpload = selectedFiles.filter((file) =>
        new_files.some(
          (nf) => nf.originalname === file.name && nf.size === file.size
        )
      );

      if (filesToUpload.length === 0) {
        showErrorToast("No valid new files found to upload.");
        return;
      }

      /* ===========================
       4️⃣ UPLOAD NEW FILES ONLY
    ============================ */
      const uploadFormData = new FormData();
      filesToUpload.forEach((file) => uploadFormData.append("files", file));
      uploadFormData.append("mode", role);
      uploadFormData.append("description", Description);
      // ✅ send only ID
      uploadFormData.append("userObj", JSON.stringify(selectedUserObj));

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/upload`,
        uploadFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      /* ===========================
       5️⃣ UI FEEDBACK
    ============================ */
      const uploaded_count = response?.data?.uploaded_files?.length || 0;
      const duplicate_count = duplicates.length;

      if (uploaded_count > 0 && duplicate_count > 0) {
        toast.success(
          `Uploaded ${uploaded_count} file(s). ${duplicate_count} duplicate(s) skipped.`
        );
      } else if (uploaded_count > 0) {
        showSuccessToast("Files uploaded successfully!");
      }

      /* ===========================
       6️⃣ CLEANUP & NEXT STEPS
    ============================ */
      setSelectedFiles([]);
      fileInputRef.current.value = null;
      fetchUploadedFiles();

      const uploadIds =
        response.data.uploaded_files?.map((f) => f.python_file_uuid) || [];

      if (uploadIds.length > 0) {
        await fetchSummaryFromBackend(uploadIds);
      }
    } catch (err) {
      console.error("Upload failed:", err);
      showErrorToast("File upload failed! Please try again.");
    } finally {
      setIsAdded(false);
    }
  };

  const handlePreview = async (file) => {
    try {
      const res = await fetch(
        `${
          process.env.REACT_APP_API_URL
        }/uploaded-files/download/${encodeURIComponent(file.storedName)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) throw new Error("Failed to fetch preview");

      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);

      setSelectedFile({ ...file, previewUrl: blobUrl }); // Preview state set with blob URL
      setShowModal(true); // Show modal
    } catch (err) {
      console.error("Preview fetch failed:", err);
      showErrorToast("Unable to preview file.");
    }
  };

  // const summaryData = [
  //   { label: "Files", value: 12345, percent: 23 },
  //   { label: "Text", value: 334545, percent: 37 },
  //   { label: "Website", value: 6789, percent: 30 },
  //   { label: "Q&A", value: 2345, percent: 20 },
  //   { label: "YouTube", value: 67890, percent: 30 },
  // ];

  const [summaryStats, setSummaryStats] = useState({
    totalFiles: 0,
    totalSize: 0,
    byType: [],
  });

  const calculateSummaryStats = (files) => {
    if (!files || files.length === 0) return;

    let totalFiles = files.length;
    let totalSize = files.reduce((sum, f) => sum + (f.size || 0), 0);

    // Group by extension
    const grouped = {};
    files.forEach((file) => {
      const ext = file.name?.split(".").pop().toLowerCase();
      if (!grouped[ext]) grouped[ext] = { count: 0, size: 0 };
      grouped[ext].count += 1;
      grouped[ext].size += file.size || 0;
    });

    // Convert to array with percentage
    const byType = Object.entries(grouped).map(([ext, { count, size }]) => ({
      type: `.${ext}`,
      count,
      size,
      percent: ((count / totalFiles) * 100).toFixed(2),
    }));

    setSummaryStats({ totalFiles, totalSize, byType });
  };

  const fetchUsers = async () => {
    try {
      const res = await api.get(BASE_URL, {
        headers: { Authorization: `Bearer ${token}` },
        params: { limit: "all" },
      });
      setUsers(res.data.data); // 👈 store user list
    } catch (error) {
      console.error("Failed to fetch users", error);
      showErrorToast(TOAST_MESSAGES.USER.FETCH_ERROR);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div
      className="container-fluid mt-2 h-100"
      style={{ paddingBottom: "800px" }}
    >
      <div className="row">
        {/* LEFT: File Upload and Preview */}
        <div className="col-lg-8">
          <div className="card profile shadow-sm rounded-lg p-4">
            <h5 className="fw-bold mb-3">Upload Documents</h5>
            {/* Radio Buttons */}
            <div className="d-flex gap-4 justify-content-between align-items-center mb-2">
              <div className="gap-2 d-flex">
                <label className="radio-label mb-0">
                  <input
                    type="radio"
                    name="role"
                    value="personal"
                    checked={role === "personal"}
                    onChange={() => setRole("personal")}
                  />
                  <span className="ms-2">Personal</span>
                </label>

                <label className="radio-label mb-0">
                  <input
                    type="radio"
                    name="role"
                    value="global"
                    checked={role === "global"}
                    onChange={() => {
                      setRole("global");
                      setSelectedUserId("");
                    }}
                  />
                  <span className="ms-2">Gobal</span>
                </label>
              </div>
              {role === "personal" && (
                <div className="col-md-4">
                  <select
                    className="form-select"
                    value={selectedUserId}
                    onChange={(e) => {
                      const userId = e.target.value; // 👈 keep string

                      const user = users.find(
                        (u) => String(u.user_id) === userId
                      );

                      // console.log("Found user:", user); // 🔍 debug

                      setSelectedUserId(userId);
                      setSelectedUserObj(user);
                    }}
                    disabled={role === "global"}
                  >
                    <option value="">Select User</option>
                    {users.map((user) => (
                      <option key={user.user_id} value={user.user_id}>
                        {user.user_name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>

            {/* Top Row */}
            <div className="row g-3 mb-3 d-flex justify-content-center">
              {/* <div className="col-md-4">
                <select className="form-select" disabled>
                  <option value="">Category</option>
                  <option>Documents</option>
                  <option>Images</option>
                  <option>Reports</option>
                </select>
              </div>

              <div className="col-md-4">
                <div className="folder-select">
                  <select className="form-select" disabled>
                    <option value="">Select Folder</option>
                    <option>Folder 1</option>
                    <option>Folder 2</option>
                  </select>
                </div>
              </div> */}

              {/* 👇 User Dropdown */}
              {/* <div className="col-md-4">
                <select
                  className="form-select"
                  value={selectedUserId}
                  onChange={(e) => {
                    const userId = e.target.value; // 👈 keep string

                    const user = users.find(
                      (u) => String(u.user_id) === userId
                    );

                    // console.log("Found user:", user); // 🔍 debug

                    setSelectedUserId(userId);
                    setSelectedUserObj(user);
                  }}
                  disabled={role === "global"}
                >
                  <option value="">Select User</option>
                  {users.map((user) => (
                    <option key={user.user_id} value={user.user_id}>
                      {user.user_name}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>

            <div
              className="border-2 rounded p-4 mb-3 text-center"
              onClick={() => !isAdded && fileInputRef.current.click()}
              onDrop={isAdded ? (e) => e.preventDefault() : handleDrop}
              onDragOver={isAdded ? (e) => e.preventDefault() : handleDragOver}
              style={{
                cursor: isAdded ? "not-allowed" : "pointer", // 👈 show disabled cursor
                minHeight: "240px",
                borderStyle: "dashed",
                border: "dashed var(--input-border-color)",
                pointerEvents: isAdded ? "none" : "auto", // 👈 block all events while uploading
              }}
            >
              <input
                type="file"
                ref={fileInputRef}
                multiple
                className="d-none "
                // accept=".pdf,.docx,.txt,.doc,.pptx,.xlsx,.mp3,.wav,.aac,.flac,.mp4,.mov,.avi,.mkv,.flv,.png,.jpg,.jpeg,.gif,.bmp,.tiff"
                onChange={handleFileSelect}
              />

              {selectedFiles.length === 0 && (
                <div className="">
                  {/* <i className="bi bi-cloud-arrow-up fs-1" /> */}
                  <div className="w-100 d-flex align-items-center justify-content-center">
                    <div
                      className="rounded-circle align-self-center border border-2 d-flex justify-content-center align-items-center p-2 p-md-3 mb-3"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderStyle: "dashed",
                        border: "dashed var(--input-border-color)",
                        // borderColor: "var(--border-color)",
                        backgroundColor: "var(--bot-bubble-color)",
                      }}
                    >
                      <img
                        src={uploadIcon}
                        alt="Upload"
                        className="icon-image1"
                        style={{
                          width: "40px ",
                          // maxHeight: "40px",

                          transition: "filter 0.3s ease",
                        }}
                      />
                    </div>
                  </div>
                  <p className="mb-1 fw-semibold">Drag and Drop here</p>
                  <p className=" fw-semibold mb-1">or</p>
                  <button
                    className="bg-secondary"
                    type="button"
                    onClick={(e) => e.currentTarget.blur()}
                    disabled={isAdded}
                    style={{
                      marginTop: "8px",
                      padding: "8px 16px",
                      // backgroundColor: isAdded ? "#cccccc" : "var(--secondary-color)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: isAdded ? "not-allowed" : "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i className="bi bi-folder2-open" /> Browse Files
                  </button>
                  <p
                    className="small mt-2 supported-text"
                    style={{ color: "var(--dark-color)" }}
                  >
                    {/* Supported: .pdf, .doc, .docx, .txt, .mp3, .wav, .mp4,
                    .avi, .mov, .mkv, .png, .jpg, .jpeg, .ppt, .pptx */}
                    {/* Supported: .pdf, .docx, .txt, .mp3, .mp4, .png, .jpeg, pptx */}
                  </p>
                </div>
              )}

              {selectedFiles.length > 0 && (
                <div
                  className="d-flex flex-column gap-2 overflow-auto"
                  style={{ maxHeight: "200px" }}
                >
                  {selectedFiles.map((file, index) => (
                    <div
                      className="d-flex justify-content-between align-items-center border rounded px-3 py-2"
                      key={index}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-file-earmark-fill  fs-5" />
                        <span className="fw-semibold">{file.name}</span>
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(index);
                        }}
                        className="btn btn-sm text-danger border-0"
                      >
                        <i className="bi bi-trash-fill fs-5" />
                      </button>
                    </div>
                  ))}

                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="custom-btn d-flex align-items-center gap-2 mx-auto"
                      onClick={(e) => {
                        if (isAdded) return; // 👈 block click during upload
                        e.stopPropagation();
                        fileInputRef.current.click();
                        e.currentTarget.blur();
                      }}
                      disabled={isAdded} // 👈 disable button
                      style={{
                        opacity: isAdded ? 0.6 : 1,
                        cursor: isAdded ? "not-allowed" : "pointer",
                      }}
                    >
                      <i className="bi bi-plus-lg" /> Add More Files
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Description */}
            <div
              className="fw-semibold mb-1 d-flex align-items-center fs-6 fs-md-5 mt-2"
              style={{ color: "var(--dark-color)" }}
            >
              Description
            </div>

            <textarea
              className="form-control custom-textarea rounded-3 px-2 px-md-4 py-1 py-md-2 mb-2"
              placeholder="Write here..."
              value={Description}
              onChange={(e) => setDescription(e.target.value)}
              style={{
                borderWidth: "1.5px",
                minHeight: "40px",
                resize: "vertical",
                fontSize: "14px",
                backgroundColor: "var(--background-color)",
                borderColor: "var(--border-color)",
                color: "var(--dark-color)",
              }}
            />

            <div className="d-flex gap-3">
              <button
                type="button"
                className="cancle-btn flex-fill border-1 w-50 fw-semibold"
                // style={{ borderColor: "#3e3e3e" }}
                onClick={handleCancel}
                disabled={isCancelling}
              >
                {isCancelling ? (
                  <>
                    {/* <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    /> */}
                    Cancelling...
                  </>
                ) : (
                  "Cancel"
                )}
              </button>
              <button
                className="custom-btn w-50 fw-semibold "
                // style={{ backgroundColor: "#3e3e3e" }}
                onClick={handleUpload}
                disabled={isAdded}
              >
                {isAdded ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>

          <div className="mt-4">
            <div
              className="table-responsive"
              style={{ maxHeight: "330px", overflowY: "auto" }}
            >
              <table className="table trainingFiles-table text-left align-middle mb-0">
                <thead className="">
                  <tr>
                    <th>Document Name</th>
                    <th>Type</th>
                    <th>Size</th>
                    <th>Status</th>
                    <th>Uploaded On</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {uploadedFilesList.length > 0 ? (
                    uploadedFilesList.map((file, index) => (
                      <tr key={file.id || index} className="bg-light">
                        <td
                          style={{
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={file.name}
                        >
                          {file.name}
                        </td>
                        <td
                          style={{
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {formatFileType(file.type, file.name)}
                        </td>
                        <td>{formatFileSize(file.size)}</td>
                        <td className="text-left">
                          <select
                            className={`badge ${
                              file.approval_status === "approved"
                                ? "bg-success"
                                : file.approval_status === "pending"
                                ? "bg-warning"
                                : "bg-danger"
                            }`}
                            value={file.approval_status} // ✅ FIXED
                            onChange={(e) =>
                              handleChangeStatus(file.id, e.target.value)
                            }
                          >
                            <option value="pending">Pending</option>
                            <option value="approved">Approved</option>
                            <option value="rejected">Rejected</option>
                          </select>
                        </td>

                        <td>
                          {formatDateToUserTimeZone(new Date(file.updatedAt))}
                        </td>
                        {/* <td>
                            <button
                              className="btn btn-sm btn-outline-dark"
                              onClick={() => {
                                handlePreview(file); // ✅ Call preview logic
                              }}
                            >
                              <i className="bi bi-eye" />
                            </button>
                          </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-muted">
                        There are no document(s) in this section.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {/* {showModal && selectedFile && (
                <div className="modal show d-block" tabIndex="-1" role="dialog">
                  <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">{selectedFile.name}</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => {
                            setShowModal(false);
                            setSelectedFile(null);
                          }}
                        ></button>
                      </div>
                      <div className="modal-body" style={{ height: "80vh" }}>
                        {selectedFile.type.includes("pdf") ? (
                          <iframe
                            src={selectedFile.previewUrl}
                            title="PDF Preview"
                            width="100%"
                            height="100%"
                          ></iframe>
                        ) : selectedFile.type.includes("text") ? (
                          <iframe
                            src={selectedFile.previewUrl}
                            title="Text Preview"
                            width="100%"
                            height="100%"
                          ></iframe>
                        ) : selectedFile.type.includes("image") ? (
                          <img
                            src={selectedFile.previewUrl}
                            alt={selectedFile.name}
                            className="img-fluid"
                          />
                        ) : (
                          <p>Preview not supported for this file type.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
            </div>
          </div>
        </div>

        {/* RIGHT - Summary Card */}
        <div className="col-lg-4">
          <div className="card profile p-4 shadow-sm">
            <h5 className="fw-semibold mb-4">Summary</h5>
            <div className="d-flex justify-content-center align-items-center mb-4 position-relative">
              <svg
                width="140"
                height="140"
                viewBox="0 0 36 36"
                className="circular-chart"
              >
                <path
                  className="circle-bg"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#eee"
                  strokeWidth="2"
                />
                <path
                  className="circle"
                  strokeDasharray="72, 100"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#3e3e3e"
                  strokeWidth="2"
                />
              </svg>
              <div className="position-absolute text-center">
                <div className=" small">Complete</div>
                <div className="fw-bold fs-2">72%</div>
              </div>
            </div>
            <div className="row text-center mb-4">
              <div className="col">
                <div className=" small fw-semibold">Total Size</div>
                <div className=" fw-semibold">10,589</div>
              </div>
              <div className="col">
                <div className=" small fw-semibold">Limits</div>
                <div className=" fw-semibold">12,360</div>
              </div>
            </div>

            {[
              { type: ".pdf", value: 80 },
              { type: ".docx", value: 60 },
              { type: ".txt", value: 40 },
              { type: ".png", value: 50 },
              { type: ".jpg", value: 70 },
              { type: ".mp4", value: 50 },
            ].map((doc, idx) => (
              <div key={idx} className="mb-3">
                <div className="d-flex justify-content-between small fw-semibold">
                  <span className="text-secondary">{doc.type}</span>
                </div>
                <div className="progress" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-dark"
                    role="progressbar"
                    style={{ width: `${doc.value}%` }}
                  />
                </div>
              </div>
            ))}
            {/* {summaryStats.byType.length > 0 ? (
              summaryStats.byType.map((doc, idx) => (
                <div key={idx} className="mb-3">
                  <div className="d-flex justify-content-between small fw-semibold">
                    <span className="text-secondary">{doc.type}</span>
                  </div>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-dark"
                      role="progressbar"
                      style={{ width: `${doc.percent}%` }}
                    />
                  </div>
                </div>
              ))
            ) : (
              <p className="text-muted">No data available</p>
            )} */}
          </div>
        </div>
      </div>

      {/* 🆕 Summary Modal */}
      {/* {showSummaryModal && (
        <div className="modal-backdrop-custom d-flex justify-content-center align-items-center">
          <div
            className="p-4 rounded-3 text-start position-relative"
            style={{
              backgroundColor: "#ffffff",
              width: "90%",
              maxWidth: "800px",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <img
              src={crossIcon}
              alt="Close"
              className="custom-close-icon"
              onClick={() => setShowSummaryModal(false)}
            />

            <p className="fw-bold mt-2 ps-3 mb-3">
              Summaries from uploaded Documents
            </p>

            {summaryDataList.length === 0 ? (
              <p>No summaries available.</p>
            ) : (
              summaryDataList.map((summary, index) => (
                <div key={index} className="rounded-3 p-3 mb-3 bg-light">
                  <div className="mb-2 d-flex align-items-center gap-3">
                    {summary.type === "file" ? (
                      <img src={fileIcon} alt="file" width={20} height={20} />
                    ) : (
                      <img src={linkIcon} alt="link" width={20} height={20} />
                    )}
                    <div>
                      <div className="text-muted text-truncate">
                        {summary.name || "Untitled"}
                      </div>
                    </div>
                  </div>

                  <div className="position-relative">
                    <textarea
                      className="form-control"
                      rows={5}
                      value={summary.summary || "No summary available."}
                      readOnly
                    />
                    <button
                      className="btn btn-link position-absolute text-white end-0 mt-1 bg-dark me-2"
                      onClick={() =>
                        regenerateSummary(summary?.approval_request_id, index)
                      }
                      disabled={loadingIndex === index} // 🚫 prevent double click
                    >
                      {loadingIndex === index ? (
                        <span className="spinner-border spinner-border-sm text-light" />
                      ) : (
                        <BsArrowRepeat size={18} />
                      )}
                    </button>
                  </div>
                </div>
              ))
            )}

            <div className="text-center mt-3">
              <button
                className="btn bg-dark text-white w-25"
                onClick={() => setShowSummaryModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default TrainingManagement;
